/* Sentinel cart contract v1. No Shopify prices or discounts are overridden. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.SentinelCore = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  var DAY = 86400000;
  function fail(message) { throw new Error(message); }
  function string(value, max) { return typeof value === 'string' ? value.slice(0, max || 300) : ''; }
  function numericId(value, type) {
    var raw = String(value || '');
    var match = raw.match(new RegExp('^(?:gid://shopify/' + type + '/)?([0-9]+)$'));
    return match ? match[1] : fail('Invalid Shopify ' + type + ' ID.');
  }
  function cents(value) {
    var number = Number(value);
    if (!Number.isFinite(number) || number < 0) fail('Invalid price.');
    return Math.round(number * 100);
  }
  function safeUrl(value, base, sameOrigin) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      var url = new URL(value, base);
      if (!['https:', 'http:'].includes(url.protocol)) return '';
      if (sameOrigin && url.origin !== new URL(base).origin) return '';
      return url.href;
    } catch (_) { return ''; }
  }
  function normalizeOffer(raw, config, id, now, base) {
    if (!raw || !Array.isArray(raw.lines) || !raw.lines.length || raw.lines.length > 100) fail('Please select a valid offer.');
    var offer = {
      id: string(id, 100), key: string(raw.key, 100), title: string(raw.title, 200),
      bundle: string(raw.bundle, 200), origin: string(raw.origin || config.origin, 80),
      country: string(raw.country || config.country, 2).toUpperCase(),
      currency: string(raw.currency || config.currency, 3).toUpperCase(),
      productId: numericId(raw.productId, 'Product'),
      kind: raw.kind === 'protection' ? 'protection' : 'offer',
      image: safeUrl(raw.image, base, false), url: safeUrl(raw.url, base, true),
      displayedCents: raw.displayedCents,
      compareCents: Number.isSafeInteger(raw.compareCents) && raw.compareCents > raw.displayedCents ? raw.compareCents : null,
      addedAt: now, lines: []
    };
    if (!offer.title || !offer.bundle || !offer.key || !/^[A-Z]{2}$/.test(offer.country) || !/^[A-Z]{3}$/.test(offer.currency)) fail('Incomplete offer settings.');
    if (!Number.isSafeInteger(offer.displayedCents) || offer.displayedCents < 0) fail('Invalid offer total.');
    if (offer.origin !== config.origin) fail('This offer uses a different checkout configuration. Please contact us.');
    offer.lines = raw.lines.map(function (line) {
      if (!Number.isSafeInteger(line.quantity) || line.quantity < 1 || line.quantity > 100) fail('Invalid quantity.');
      var variantId = numericId(line.variantId || line.merchandiseId, 'ProductVariant');
      return {
        variantId: variantId, merchandiseId: 'gid://shopify/ProductVariant/' + variantId,
        productId: offer.productId, quantity: line.quantity,
        label: string(line.label, 200),
        unitCents: Number.isSafeInteger(line.unitCents) && line.unitCents >= 0 ? line.unitCents : null
      };
    });
    return offer;
  }
  function empty(now) { return { version: 1, revision: 0, updatedAt: now, expiresAt: now + 7 * DAY, offers: [] }; }
  function readState(raw, now, config, base) {
    if (!raw) return empty(now);
    try {
      var state = JSON.parse(raw);
      if (state.version !== 1 || !Array.isArray(state.offers) || state.offers.length > 50 || !Number.isFinite(state.expiresAt) || state.expiresAt <= now) return empty(now);
      var seen = new Set();
      state.offers = state.offers.map(function (offer) {
        if (!offer.id || seen.has(offer.id)) fail('Invalid saved cart.');
        seen.add(offer.id);
        return normalizeOffer(offer, config, offer.id, offer.addedAt, base);
      });
      state.offers = state.offers.filter(function (o) {
        return o.kind !== 'protection' || (config.protection && config.protection.enabled && o.lines.length === 1 && o.lines[0].variantId === config.protection.variantId);
      });
      if (!state.offers.some(function (o) { return o.kind !== 'protection'; })) state.offers = [];
      validateContext(state.offers);
      return state;
    } catch (_) { return empty(now); }
  }
  function validateContext(offers) {
    if (!offers.length) return;
    var first = offers[0];
    if (offers.some(function (o) { return o.country !== first.country || o.currency !== first.currency || o.origin !== first.origin; })) fail('Your cart uses another country or currency. Remove its offers before switching markets.');
    if (offers.reduce(function (n, o) { return n + o.lines.length; }, 0) > 200) fail('Your cart is full. Please complete this order first.');
  }
  function mutate(state, action, now) {
    var result = JSON.parse(JSON.stringify(state));
    if (action.type === 'add') {
      if (result.offers.length >= 50) fail('Your cart is full.');
      if (action.offer.kind === 'protection') {
        if (!result.offers.some(function (o) { return o.kind !== 'protection'; })) fail('Add an offer before shipping protection.');
        if (result.offers.some(function (o) { return o.kind === 'protection'; })) fail('Shipping protection is already selected.');
      }
      result.offers.push(action.offer);
    } else if (action.type === 'remove') result.offers = result.offers.filter(function (o) { return o.id !== action.id; });
    else fail('Invalid cart action.');
    if (!result.offers.some(function (o) { return o.kind !== 'protection'; })) result.offers = [];
    validateContext(result.offers);
    result.revision = (Number(result.revision) || 0) + 1;
    result.updatedAt = now; result.expiresAt = now + 7 * DAY;
    return result;
  }
  function buildInput(offers, tracking, eventId, config) {
    if (!offers.length) fail('Your cart is empty.');
    validateContext(offers);
    if (offers.some(function (o) { return o.origin !== config.origin; })) fail('Unsupported tracking destination.');
    var manifest = { v: 1, offers: offers.map(function (o) { return { id: o.id, key: o.key, origin: o.origin }; }) };
    var attributes = [
      { key: 'bundle', value: offers.length === 1 ? offers[0].bundle : 'multiple_offers:' + offers.length },
      { key: 'shop_origin', value: config.origin },
      { key: 'google_market', value: offers[0].country },
      { key: 'ic_event_id', value: eventId },
      { key: 'sentinela_offers_v1', value: JSON.stringify(manifest) }
    ];
    ['landing_url', 'tiktok_ttclid', 'external_id', 'meta_fbc', 'meta_fbp', 'meta_fbclid', 'google_gclid', 'google_gbraid', 'google_wbraid'].forEach(function (key) {
      if (tracking[key]) attributes.push({ key: key, value: String(tracking[key]) });
    });
    var lines = [];
    offers.forEach(function (offer) {
      // Aggregate only within this offer. Never merge distinct offer instances.
      var grouped = new Map();
      offer.lines.forEach(function (line) {
        if (grouped.has(line.variantId)) grouped.get(line.variantId).quantity += line.quantity;
        else grouped.set(line.variantId, { merchandiseId: line.merchandiseId, quantity: line.quantity,
          attributes: [
            { key: '_sentinela_offer_instance_id', value: offer.id },
            { key: '_sentinela_offer_key', value: offer.key },
            { key: '_sentinela_shop_origin', value: offer.origin }
          ] });
      });
      grouped.forEach(function (line) { lines.push(line); });
    });
    return { lines: lines, attributes: attributes, buyerIdentity: { countryCode: offers[0].country } };
  }
  function fingerprint(offers) { return JSON.stringify(offers.map(function (o) { return [o.id, o.country, o.currency, o.origin, o.displayedCents, o.lines]; })); }
  function cartQuote(cart, offers) {
    if (!cart || !cart.checkoutUrl || !cart.cost || !cart.lines || cart.lines.pageInfo.hasNextPage) fail('Checkout returned incomplete data. Please try again.');
    var currency = offers[0].currency;
    if (cart.cost.totalAmount.currencyCode !== currency || cart.cost.subtotalAmount.currencyCode !== currency) fail('Checkout returned another currency. Please review your market settings.');
    var expected = new Map(), actual = new Map();
    offers.forEach(function (o) { o.lines.forEach(function (l) {
      var key = o.id + ':' + l.variantId;
      expected.set(key, (expected.get(key) || 0) + l.quantity);
    }); });
    var contents = [], lineTotal = 0;
    cart.lines.nodes.forEach(function (line) {
      var instance = line.attributes.find(function (a) { return a.key === '_sentinela_offer_instance_id'; });
      if (!instance || !line.merchandise || line.merchandise.availableForSale === false) fail('An offer is no longer available. Please remove it and choose again.');
      var variantId = numericId(line.merchandise.id, 'ProductVariant');
      var key = instance.value + ':' + variantId;
      actual.set(key, (actual.get(key) || 0) + line.quantity);
      if (line.cost.totalAmount.currencyCode !== currency) fail('Invalid checkout currency.');
      var total = cents(line.cost.totalAmount.amount);
      lineTotal += total;
      contents.push({ variantId: variantId, productId: numericId(line.merchandise.product.id, 'Product'), quantity: line.quantity, totalCents: total });
    });
    if (expected.size !== actual.size || Array.from(expected).some(function (pair) { return actual.get(pair[0]) !== pair[1]; })) fail('Some items changed or are unavailable. Please review your offers before checkout.');
    var cartDiscount = (cart.discountAllocations || []).reduce(function (sum, d) {
      if (d.targetType !== 'LINE_ITEM') return sum;
      if (d.discountedAmount.currencyCode !== currency) fail('Invalid discount currency.');
      return sum + cents(d.discountedAmount.amount);
    }, 0);
    // Shopify subtotal includes line discounts, but excludes cart-level discounts and taxes.
    return { currency: currency, merchandiseCents: Math.max(0, cents(cart.cost.subtotalAmount.amount) - cartDiscount), totalCents: cents(cart.cost.totalAmount.amount), contents: contents, checkoutUrl: cart.checkoutUrl };
  }
  return { DAY: DAY, numericId: numericId, cents: cents, safeUrl: safeUrl, normalizeOffer: normalizeOffer,
    empty: empty, readState: readState, mutate: mutate, validateContext: validateContext,
    buildInput: buildInput, fingerprint: fingerprint, cartQuote: cartQuote };
});
